'use client';
import { CustomerKeyType } from '../../constants';
import { useWishlistCustomerKey } from '../../context';
import { useWishlistOwner } from './useWishlistOwner';
import { useWishlistService } from './useWishlistService';

export const useWishlistToggle = () => {
  const { useAddProductToWishlist, useRemoveProductFromWishlist, useGetWishlist } = useWishlistService();
  const { customerKey, customerKeyType, isOwnerResolved } = useWishlistOwner();
  const { resolveGuestCustomerKey } = useWishlistCustomerKey();

  const { data: wishlistData } = useGetWishlist(
    {
      customerKey: customerKey,
      customerKeyType: customerKeyType,
    },
    { enabled: isOwnerResolved },
  );

  const { mutate: addToWishlist } = useAddProductToWishlist();
  const { mutate: removeFromWishlist } = useRemoveProductFromWishlist();

  const toggleWishlist = (sku: string) => {
    if (!isOwnerResolved) {
      return;
    }

    const isWished = Boolean(wishlistData?.skus.includes(sku));

    if (isWished && customerKey) {
      removeFromWishlist({
        customerKey: customerKey,
        customerKeyType: customerKeyType,
        sku: sku,
      });
      return;
    }

    // A guest's first add is what creates the wishlist, so the key is minted here rather than by
    // the API: concurrent first adds must land on one wishlist instead of one each.
    const targetCustomerKey = customerKeyType === CustomerKeyType.GUEST ? resolveGuestCustomerKey() : customerKey;

    addToWishlist({
      customerKey: targetCustomerKey,
      customerKeyType: customerKeyType,
      sku: sku,
    });
  };

  return {
    wishlistData,
    toggleWishlist,
    isOwnerResolved,
  };
};
